module.exports = __webpack_public_path__ + "static/media/appointmentdirect.0d3a6fb4.svg";